<div>
  <mat-card class="offers-filter_panel">
    <mat-card-header>
      <mat-card-title
        ><h3 class="filter_color_offers">{{ rGuestBookMessages.offer.offerModalFilterLabel }}</h3></mat-card-title
      >
    </mat-card-header>
    <mat-card-content>
      <form class="filter-offers-page">
        <div class="content-mr">
          <div *ngIf="!data?.pageFromRoom" class="date-filter">
            <mat-form-field>
              <input
                name="date"
                autocomplete="off"
                [(ngModel)]="data.ArrDepDate"
                #ctrl="ngModel"
                [minDate]="data.minDate"
                readonly
                (ngModelChange)="validatedates(data.ArrDepDate)"
                matInput
                placeholder="{{ rGuestBookMessages.offer.offerArrDepPlaceholder }}"
                (onShown)="onShowPicker($event)"
                bsDaterangepicker
                [bsConfig]="bsConfig"
                #dpr="bsDaterangepicker" />
            </mat-form-field>
          </div>
          <mat-form-field>
            <input
              class="offerCode_textbox"
              name="OfferCode"
              [(ngModel)]="data.OfferCode"
              matInput
              #ctrl="ngModel"
              placeholder="{{ rGuestBookMessages.offer.offerModalOfferCodeLabel }}" />
          </mat-form-field>
        </div>
      </form>
    </mat-card-content>
    <mat-card-actions class="offers-filter-actions">
      <button class="offerNoThanksButton" mat-button (click)="onNoClick()">{{ rGuestBookMessages.offer.offerModalNoThanksButton }}</button>
      <button mat-button [hidden]="data?.pageFromRoom" (click)="clearFilter()" type="button">
        {{ rGuestBookMessages.offer.offerClearButton }}
      </button>
      <button
        mat-raised-button
        class="offerSearchButton search_button col-xs-2 col-sm-2 col-md-2 col-lg-2 col-5"
        [mat-dialog-close]="data"
        cdkFocusInitial>
        {{ rGuestBookMessages.offer.offerModalSearchButton }}
      </button>
    </mat-card-actions>
  </mat-card>
</div>
